/* eslint-disable @typescript-eslint/no-explicit-any -- legacy untyped payloads, read field by field by the settings cards */
import { SdkContext } from '../internal'
import { noteRowFrom, versionedRowWrite } from '@/lib/realtime/rowVersion'

const ROW = 'businessInformation'

export class BusinessInformationResource {
  constructor(private ctx: SdkContext) {}

  async get(): Promise<any> {
    return noteRowFrom(ROW, await this.ctx.call(
      { httpMethod: 'GET', path: '/business-information' },
      {}
    ))
  }

  /** Sends the version read (`updatedAt`); a stale save (409) asks before saving over it. */
  async save(businessData: any): Promise<any> {
    return versionedRowWrite(ROW, (v) => this.ctx.call(
      { httpMethod: 'POST', path: '/business-information', hasBody: true },
      { body: { ...businessData, ...(v ? { updatedAt: v } : {}) } }
    ))
  }

  async submit(): Promise<any> {
    return versionedRowWrite(ROW, (v) => this.ctx.call(
      { httpMethod: 'POST', path: '/business-information/submit', hasBody: true },
      { body: (v ? { updatedAt: v } : {}) }
    ))
  }

  async getStatus(): Promise<any> {
    return this.ctx.call(
      { httpMethod: 'GET', path: '/business-information/status' },
      {}
    )
  }
}
